import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { path: "/", label: "Ana Sayfa" },
  { path: "/hizmetler", label: "Hizmetlerimiz" },
  { path: "/kus-egzotik", label: "Kuş & Egzotik" },
  { path: "/pet-shop-kuafor", label: "Pet Shop & Kuaför" },
  { path: "/hakkimizda", label: "Hakkımızda" },
  { path: "/iletisim", label: "İletişim" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-white/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 shrink-0 group">
            <img
              src="/assets/images/brand-logo.jpg"
              alt="İhsan Özer Veteriner Kliniği"
              className="h-10 w-10 md:h-12 md:w-12 rounded-full object-cover ring-2 ring-white/50 group-hover:ring-primary-400 transition-all"
            />
            <div className="hidden sm:block">
              <p className={`text-sm md:text-base font-bold leading-tight transition-colors duration-300 ${scrolled ? "text-primary-950" : "text-white"}`}>
                İhsan Özer
              </p>
              <p className={`text-xs leading-tight transition-colors duration-300 ${scrolled ? "text-primary-700" : "text-white/80"}`}>
                Veteriner Kliniği
              </p>
            </div>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`relative px-3 py-2 rounded-lg text-sm font-medium transition-all duration-300 whitespace-nowrap ${
                  location.pathname === link.path
                    ? scrolled
                      ? "text-primary-700 bg-primary-50"
                      : "text-white bg-white/20"
                    : scrolled
                    ? "text-gray-700 hover:text-primary-700 hover:bg-primary-50/50"
                    : "text-white/90 hover:text-white hover:bg-white/10"
                }`}
              >
                {link.label}
                {location.pathname === link.path && (
                  <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-current" />
                )}
              </Link>
            ))}
          </div>

          {/* Right Side */}
          <div className="flex items-center gap-3">
            <a
              href="tel:05396960677"
              className={`hidden md:flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-semibold transition-all duration-300 whitespace-nowrap ${
                scrolled
                  ? "bg-primary-600 text-white hover:bg-primary-700 shadow-md hover:shadow-lg"
                  : "bg-white/20 text-white hover:bg-white/30 backdrop-blur-sm"
              }`}
            >
              <i className="ri-phone-line w-4 h-4 flex items-center justify-center" />
              0539 696 06 77
            </a>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className={`lg:hidden p-2.5 rounded-xl transition-all duration-300 ${
                scrolled ? "text-gray-700 hover:bg-gray-100" : "text-white hover:bg-white/10"
              }`}
              aria-label="Menü"
            >
              <i className={`${mobileOpen ? "ri-close-line" : "ri-menu-line"} w-5 h-5 flex items-center justify-center text-xl`} />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden bg-white border-t shadow-xl transition-all duration-300 overflow-hidden ${
          mobileOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="px-4 py-3 space-y-1">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`block px-4 py-3 rounded-xl text-sm font-medium transition-all ${
                location.pathname === link.path
                  ? "text-primary-700 bg-primary-50 font-semibold"
                  : "text-gray-700 hover:text-primary-700 hover:bg-primary-50/50"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <a
            href="tel:05396960677"
            className="flex items-center gap-2 px-4 py-3 rounded-xl text-sm font-semibold text-primary-700 bg-primary-50 mt-2"
          >
            <i className="ri-phone-line w-4 h-4 flex items-center justify-center" />
            0539 696 06 77
          </a>
        </div>
      </div>
    </nav>
  );
}
